import React, { useState } from 'react';
import ClinicLayout from './ClinicLayout';
import { Edit, Trash2, Receipt, CheckCircle } from 'lucide-react';

const ClinicAccounting = () => {
  const [payments] = useState([
    { paymentDate: '01/26/2026', payorType: 'Insurance', payor: 'Blue Cross Blue Shield', paymentMethod: 'EFT', checkNumber: 'EFT123456', paymentAmount: 425.00, appliedAmount: 425.00, whereApplied: 'CLM-003' },
    { paymentDate: '01/25/2026', payorType: 'Patient', payor: 'Smith, John', paymentMethod: 'Credit Card', checkNumber: 'CC-7890', paymentAmount: 50.00, appliedAmount: 50.00, whereApplied: 'CLM-001' },
    { paymentDate: '01/25/2026', payorType: 'Insurance', payor: 'United Healthcare', paymentMethod: 'Check', checkNumber: '892134', paymentAmount: 320.00, appliedAmount: 320.00, whereApplied: 'CLM-005' },
    { paymentDate: '01/24/2026', payorType: 'Patient', payor: 'Johnson, Mary', paymentMethod: 'Cash', checkNumber: '-', paymentAmount: 25.00, appliedAmount: 25.00, whereApplied: 'CLM-002' },
    { paymentDate: '01/24/2026', payorType: 'Insurance', payor: 'Aetna', paymentMethod: 'EFT', checkNumber: 'EFT789012', paymentAmount: 175.00, appliedAmount: 0.00, whereApplied: 'Unapplied' },
  ]);

  return (
    <ClinicLayout activeTab="accounting">
      <div className="p-4 pr-20" data-testid="clinic-accounting">
        {/* Sub Navigation Tabs */}
        <div className="flex items-center border-b border-gray-300 mb-4">
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Add New Payment/Deposit</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-white -mb-px">Payments/Deposits</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Apply Payments</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Applied Payments</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Reports</button>
        </div>

        {/* Section Header */}
        <div className="bg-gradient-to-b from-[#4a5568] to-[#2d3748] text-white px-3 py-2 text-sm font-medium mb-4">
          Payments/Deposits
        </div>

        {/* Filters */}
        <div className="bg-[#f5f5f5] border border-gray-300 p-3 mb-4">
          <div className="space-y-2 text-xs">
            {/* Row 1 */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="w-20">Date Created:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>By Date</option>
                </select>
                <input type="text" className="border border-gray-400 px-1 py-0.5 w-20" placeholder="01/26/2026" />
              </div>
            </div>
            
            {/* Row 2 */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="w-20">Search For:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>Payor Name</option>
                </select>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>Starts With</option>
                </select>
                <input type="text" className="border border-gray-400 px-1 py-0.5 w-32" />
                <button className="border border-gray-400 px-3 py-0.5 bg-gray-100">Search</button>
              </div>
            </div>

            {/* Row 3 - Display Filters */}
            <div className="flex items-center gap-4 flex-wrap">
              <span className="font-medium">Display Filter:</span>
              <div className="flex items-center gap-2">
                <label>Office:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Payment:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Payor Type:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="border border-gray-300">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-[#1e3a5f] text-white">
                <th className="p-1 border border-gray-400 text-left">Payment Date</th>
                <th className="p-1 border border-gray-400 text-left">Payor Type</th>
                <th className="p-1 border border-gray-400 text-left">Payor</th>
                <th className="p-1 border border-gray-400 text-left">Payment Method/Description</th>
                <th className="p-1 border border-gray-400 text-left">Check Number</th>
                <th className="p-1 border border-gray-400 text-right">Payment Amount</th>
                <th className="p-1 border border-gray-400 text-right">Applied Amount</th>
                <th className="p-1 border border-gray-400 text-left">Where Applied</th>
                <th className="p-1 border border-gray-400 text-center">Edit</th>
                <th className="p-1 border border-gray-400 text-center">Del</th>
                <th className="p-1 border border-gray-400 text-center">Recpt</th>
                <th className="p-1 border border-gray-400 text-center">Apply</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="p-1 border border-gray-300">{payment.paymentDate}</td>
                  <td className="p-1 border border-gray-300">{payment.payorType}</td>
                  <td className="p-1 border border-gray-300 font-medium">{payment.payor}</td>
                  <td className="p-1 border border-gray-300">{payment.paymentMethod}</td>
                  <td className="p-1 border border-gray-300">{payment.checkNumber}</td>
                  <td className="p-1 border border-gray-300 text-right">${payment.paymentAmount.toFixed(2)}</td>
                  <td className="p-1 border border-gray-300 text-right">${payment.appliedAmount.toFixed(2)}</td>
                  <td className="p-1 border border-gray-300 text-[#2563eb] cursor-pointer hover:underline">{payment.whereApplied}</td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Edit className="w-3 h-3 inline cursor-pointer text-blue-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Trash2 className="w-3 h-3 inline cursor-pointer text-red-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Receipt className="w-3 h-3 inline cursor-pointer text-purple-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    {payment.whereApplied === 'Unapplied' && (
                      <CheckCircle className="w-3 h-3 inline cursor-pointer text-green-600" />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-3 flex items-center gap-2 text-xs">
          <span>|◀ ◀◀</span>
          <span>Page</span>
          <input type="text" className="border border-gray-400 w-8 text-center" defaultValue="1" />
          <span>of 1</span>
          <span>▶▶ ▶|</span>
          <select className="border border-gray-400 px-1">
            <option>10</option>
          </select>
          <span className="ml-4 text-gray-500">Showing 1 to {payments.length} of {payments.length} entries</span>
        </div>
      </div>
    </ClinicLayout>
  );
};

export default ClinicAccounting;
